import styled from 'styled-components';
import media from '@theme/media';

export const Title = styled.div`
  font-size: 20px;
`;

export const ImgWrapper = styled.div`
  width: 100%;
  margin-bottom: 35px;
`;

export const ButtonContainer = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

export const AttendeeHeaderContainer = styled.div`
  display: flex;
  ${media.small} {
    flex-direction: column;
  }
`;



// WEBPACK FOOTER //
// ./components/layout/Header.js